export default __webpack_public_path__ + "static/loader-bg-3ece2f51d0d7069432a4dcaa66dc544e.png";